import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { makeStateKey, TransferState } from '@angular/platform-browser';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { filter, first, tap } from 'rxjs/operators';
import { isNotEmpty } from 'src/app/core/guards/type.guards';
import { EventsService } from '../services/events.service';
import { IEvent, IRepeatEvent } from 'src/app/shared/interfaces';
import { SeoService } from 'src/app/shared/services/seo.service';
import { DaysOfWeekPipe } from 'src/app/shared/pipes/day-of-week.pipe';
import { TwoDatesFormat } from 'src/app/shared/pipes/two-dates.pipe';
import { environment } from 'src/environments/environment';
import { UtilitiesService } from 'src/app/shared/services/utilities.service';

@Injectable()
export class EventPageResolver implements Resolve<any> {

    constructor(
        private eventsService: EventsService,
        @Inject(PLATFORM_ID) private platformId,
        private twoDatesPipe: TwoDatesFormat,
        private dayOfWeekPipe: DaysOfWeekPipe,
        private router: Router,
        private seoService: SeoService,
        private utils: UtilitiesService,
        private transferState: TransferState) { }

    resolve(route: ActivatedRouteSnapshot): Observable<any> {

        this.utils.startSpinner();

        // if (!isPlatformServer(this.platformId)) {
        //   return of(null);
        // }

        const id = route.params?.id;
        const username = route.params?.username;
        const type = route?.params?.type;
        const KEY = makeStateKey<any>('event-' + username ? username : id);
        if (this.transferState.hasKey(KEY)) {
            const event: any = this.transferState.get<any>(KEY, null);
            this.transferState.remove(KEY);
            this.applySEO(event);
            return of(event);
        }
        else {
            const obs = username
                ? this.eventsService.findEventByUsename$(username, type)
                // FOR FETCHING WITH ID
                : type === "REPEAT"
                    ? this.eventsService.repeatEvent$(id)
                    : this.eventsService.event$(id)

            return obs.pipe(
                filter(isNotEmpty),
                tap(en => {
                    this.applySEO(en);
                    if (isPlatformServer(this.platformId)) {
                        this.transferState.set(KEY, en);
                    }
                }),
                first()
            );
        }
    }

    private applySEO(event: IEvent | IRepeatEvent | any) {
      const dates: string = event?.startDate
        ? this.twoDatesPipe.transform(event.startDate, event.endDate)
        : `${this.dayOfWeekPipe.transform(event.daysOfWeek)} ${event.startTime}-${event.endTime
        }`;
      this.seoService.updateMeta(
        `${event.title}${event.entity ? " at " + event.entity.title : ""}, ${event.city
        } - Ping Culture`,
        `${dates} - ${event.entity?.title ? event.entity.title + ' - ' : ''}${event.description ? event.description + '. ' : ''}Full live-updating lineups, tickets, artist info, and directions.`,
        this.router?.url || null,
        event.images?.length ? environment.aws.s3Url + 'events/' + event.images[0] : null
      );

      this.seoService.createLinkForCanonicalURL(`https://ping-culture.com/events/${event.username ? 'event/' + event.type + '/' + event.username : 'type/' + event.type + '/' + event.username}`);
    }
}
